import React, { Component } from 'react';
import App_data from '../../config/App_data';
import { browserHistory } from 'react-router';
import  FD from '../../RestAPI/fetchData';
import './Auth.css';
import language from '../../../assets/languages/language'

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email : this.props.params.mailid,
      tokenid : this.props.params.tokenid, 
      password:'',
      con_password:'', 
      passwordError:'',
      con_passwordError:'',  
      message:'',
      resetbox:'block',
      successbox:'card hide_block',
      displaytext:'hide_block'
    }
  }
  updatePassword(e){
    this.setState({
        password: e.target.value,
        passwordError:''
    });
  }

  conPassword(e){
    this.setState({
        con_password: e.target.value,
        con_passwordError:''
    });
  }

  loginPage()
  {
    browserHistory.push('/');
  }

  forgetPassword(){
    browserHistory.push(
    {
      pathname: '/',
      state: {forgotOpenStatus:true}
    });
  }

  resetPassword(event){
    event.preventDefault();
    if(this.state.password==="")
    {
      this.setState({displaytext:'show_block'});
      this.setState({passwordError:`${language.LC().Password_is_Required}`});
      return;
    }
    if(this.state.password.length < 6)
    {
      this.setState({displaytext:'show_block'});
      this.setState({passwordError:`${language.LC().Password_at_least_6_characters_long}`});
      return;
    }
    if(this.state.con_password==="")
    {
      this.setState({displaytext:'show_block'});
      this.setState({con_passwordError:`${language.LC().Confirm_Password_is_Required}`});
      return;
    }
    if(this.state.password!==this.state.con_password)
    {
      this.setState({displaytext:'show_block'});
      this.setState({con_passwordError:`${language.LC().Password_didnt_match}`});
      return;
    }
    else{
      var data = {idname:this.state.email,password:this.state.password,passwordtoken:this.state.tokenid};
      FD.callAPI(App_data.backend_api+'/user/resetPassword',data).then( resp => {
        if(resp.success)
        {
          this.setState({displaytext:'hide_block'});
          this.setState({resetbox:'card hide_block'});
          this.setState({successbox:'card-block'});
        }
        else
        {
          this.setState({displaytext:'show_block', message:`${language.LC().Session_has_been_Expired}`});
        }
      });   
    }

  }

  render() {
    if(this.props.params.tokenid && this.props.params.mailid)
    {
     // console.log('Parameter Exist');
    }
    else{
      browserHistory.push(
      {
        pathname: '/',
        state: {forgotOpenStatus:true}
      });
    }
    return (
      <div className="reset-full-wraper">
        <div className="login-main-wraper">
          <div className="d-flex login-img-main-block align-items-center">
          <div className={"login-main-block " +this.state.resetbox}>
            <h1 className="reset-heading">
            {language.LC().RESET_PASSWORD}
            </h1>
            <div className={"justify-content-center"}>
              <div className="login-block">
                <div className="reset-input-tile">
                  <form onSubmit={this.resetPassword.bind(this)}>
                    <p className={this.state.displaytext+" text-danger"}>{this.state.message}</p>
                    <div className="form-group">
                      <input type="password" className="form-control" placeholder="Password" value={this.state.password} onChange={this.updatePassword.bind(this)} />
                      <p className={this.state.displaytext+" text-danger"}>{this.state.passwordError}</p>
                    </div>
                    <div className="form-group">
                      <input type="password" className="form-control" placeholder="Confirm Password" value={this.state.con_password} onChange={this.conPassword.bind(this)} />
                      <p className={this.state.displaytext+" text-danger"}>{this.state.con_passwordError}</p>
                    </div>
                    <button className="btn btn-primary reset-button btn-block pointer_class">{language.LC().RESET_PASSWORD}</button>
                    <div className="divider"></div>
                    <button className="btn btn-primary resendEmail-button btn-block pointer_class" onClick={this.forgetPassword.bind(this)}>{language.LC().RESEND_MAIL}</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className={"success-main-block " +this.state.successbox}>
            <div className="text-center">
              <img src={App_data.frontend_url+"/img/check.png"} alt="" className="success-img"/>
            </div>
            <h1 className="success-heading">
            {language.LC().PASSWORD_RESET_SUCCESSFULLY}
            </h1>
            <button className="btn btn-primary login-button btn-block pointer_class" onClick={this.loginPage.bind(this)}>{language.LC().LOGIN}</button>
          </div>
          <div className="login-image"></div>
        </div>
      </div>
    </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/views/Pages/Auth/ResetPassword.js